import { useState } from "react";
import { Select } from "antd";

const { Option } = Select;

const FREE_TEXT_KEY = "\x00__freetext__";
const MAX_FREE_TEXT_LENGTH = 200;
const CONTROL_CHAR_RE = /[\x00-\x1F\x7F]/g;

const sanitizeFreeText = (val: string): string =>
  val.replace(CONTROL_CHAR_RE, "").slice(0, MAX_FREE_TEXT_LENGTH);

interface FreeTextSelectOption {
  title: string;
  value: string | boolean;
}

interface FreeTextSelectProps {
  options?: FreeTextSelectOption[];
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  loading?: boolean;
  allowClear?: boolean;
}

const FreeTextSelect = ({
  options = [],
  value,
  onChange,
  placeholder,
  disabled,
  loading,
  allowClear = true,
}: FreeTextSelectProps) => {
  const [inputValue, setInputValue] = useState<string>("");

  const showFreeText =
    inputValue &&
    inputValue.toLowerCase() !== (value ?? "").toLowerCase() &&
    !options.some(
      (p) => (p.title ?? "").toLowerCase() === inputValue.toLowerCase()
    );

  return (
    <Select
      value={value}
      onChange={onChange}
      allowClear={allowClear}
      showSearch
      placeholder={placeholder}
      disabled={disabled}
      loading={loading}
      onSearch={(val) => setInputValue(sanitizeFreeText(val))}
      onSelect={() => setInputValue("")}
      filterOption={(input, option) =>
        String(option?.children ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    >
      {options.map((el) => (
        <Option key={el.title} value={el.value}>
          {el.title}
        </Option>
      ))}
      {showFreeText && (
        <Option key={FREE_TEXT_KEY} value={inputValue}>
          {`Use "${inputValue}"`}
        </Option>
      )}
    </Select>
  );
};

export default FreeTextSelect;
